import React from 'react';

import SessionForm, { sessionForms } from '../components/Auth/SessionForm';
import retrievePath from '../lib/iris';

const SignInModal = ({ redirectUrl }: { redirectUrl?: string }) => {
  const [form, setForm] = React.useState(sessionForms[0]);

  return (
    <SessionForm
      form={form}
      redirectUrl={redirectUrl}
      onFormChange={(e) => {
        e.preventDefault();
        setForm(sessionForms.find(({ path }) => retrievePath(e.currentTarget.href) === path)!);
      }}
    />
  );
};

export default SignInModal;
